/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ColumnMultiseriesGroup from '@fusioncharts/charts/src/dataset/groups/column-multiseries';

let key = 'manager-defaultVcanvasGroup-lines',
  vcanvasGroup = 'defaultVcanvasGroup';
/**
 * class for marimekko group manager
 */
class BoxAndWhiskerMultiSeriesGroup extends ColumnMultiseriesGroup {
  /**
  * Create child containers
  */
  createContainer () {
    super.createContainer();
    let manager = this,
      pContainer = manager.getLinkedParent().getChildContainer(vcanvasGroup); // eslint-disable-line good-practices/no-single-usage-variable

    !manager.getChildContainer(key) && manager.addChildContainer(key,
      // create group
      manager.getFromEnv('animationManager').setAnimation({
        el: 'group',
        component: manager,
        attr: { name: key },
        container: pContainer
      }));
  }
}

export default BoxAndWhiskerMultiSeriesGroup;
